/* eslint-disable no-console */
import { monitor } from './monitor'

export const logger = {
    info: (...args) => {
        console.info(...args)
        monitor.aegisInstance.info(...args)
    },
    warn: (...args) => {
        console.warn(...args)
        monitor.aegisInstance.info(...args)
    },
    error: (...args) => {
        console.error(...args)
        monitor.aegisInstance.error(...args)
    },
}
